import React from "react"
import { PrimitiveChip } from "@/primitives/PrimitiveChip"
import { FeatureType } from "@/components/Sidebar/protocols"
import useStyles from "@/components/Sidebar/FeatureStatusChip/styles"

type FeatureStatusChipProps = {
	type: FeatureType
}

const featureTypeToLabel: Record<FeatureType, string> = {
	new: "Novo",
	upcoming: "Em breve"
}

export const FeatureStatusChip = ({ type }: FeatureStatusChipProps) => {
	const classes = useStyles()

	return <PrimitiveChip label={featureTypeToLabel[type]} size="small" sx={classes[type]} />
}
